function PhoneData() {
  return {
    stationMessage: ""
  }
}

export { PhoneData };
